export const removeStorageKeysStartingWith = (prefix: string): void => {
  for (let index = localStorage.length - 1; index >= 0; index--) {
    const key = localStorage.key(index);

    if (key?.startsWith(prefix)) {
      localStorage.removeItem(key);
    }
  }
};
